/* src/app/components/notification/notification.component.scss */
.list-wrapper ul.notification-list li {
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul.notification-list li .badge-count {
  bottom: 15px !important;
  padding: 1px 7px !important;
}
.list-wrapper ul.notification-list li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-top: 1px solid #4bf768;
  border-bottom: 1px solid #4bf768;
}
.list-wrapper ul.notification-list li.active .list-active,
.list-wrapper ul.notification-list li.active .text-clr-grey {
  color: var(--listcolor) !important;
}
.list-wrapper ul.notification-list li:hover {
  background: var(--listbackgoundhover) !important;
}
.se-p.is-notification .menu-options.level,
.se-p.is-chat .menu-options.level {
  padding: 24px 11px 13px;
}
/*# sourceMappingURL=notification.component.css.map */
